import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskString'
})
export class MaskStringPipe implements PipeTransform {

  transform(value: string): string {
    // Check if the value is longer than 6 characters
    if (value && value.length > 9) {
      const maskedPart = value.slice(0, -9).replace(/./g, '*');
      const visiblePart = value.slice(-9); 
      return maskedPart + visiblePart;
    }
    return value;
  }

}
